import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TKycSection } from '@/features/kyc/components/userInformation/InformationSection';

import { useAppSelector } from '@/hooks/redux-helpers';

import { TaxResidenceSummary } from '@/features/user/components/CreateUser/TaxResidenceSummary';

import { selectTaxResidencesByUserId } from '@/store/selectors';

import { IUser } from '@/features/user/store/user.model';

export function useTaxResidencesDetailsProps(user: IUser) {
  const { t } = useTranslation();
  const taxResidences = useAppSelector((state) => selectTaxResidencesByUserId(state, user?.userId));

  const taxResidenceData = useMemo(
    () =>
      ({
        subTitle: t('pages.currentProfiles.profile.taxResidence.cardTitle'),
        categories: [
          {
            items: [
              {
                label: t('pages.dashboard.createUser.form.usTaxResident'),
                value:
                  Number(user?.specifiedUSPerson || 0) === 1
                    ? t('translation:components.molecules.forms.yes')
                    : t('translation:components.molecules.forms.no'),
              },
            ],
          },
          {
            component: <TaxResidenceSummary taxResidences={taxResidences} />,
          },
        ],
      }) as TKycSection,
    [t, taxResidences, user?.specifiedUSPerson],
  );

  return { taxResidenceData };
}
